import { Navigate } from "react-router-dom";
import { FaPiggyBank } from "react-icons/fa";
import { SavingsViewMain } from "../Components/SavingsViewMain";

export const SavingsModule = () => [
    {
        views: "PRIVATE", path: "/savings/:tab", component: <SavingsViewMain />,
        roles: null, permissions: null, label: "Ahorrador", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/savings", component: <Navigate to="/savings/summary" replace />,
        roles: null, permissions: null, label: "Ahorrador", icon: <FaPiggyBank />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
